import { MutationTree } from 'vuex';
import { ImageViewerStore, ImageContent } from './types';

const mutations: MutationTree<ImageViewerStore> = {
  setImage(state, imageViewer: ImageContent) {
    state.images.push(imageViewer);
  }
};

export default mutations;
